import Layout from '@/layout';
var roleRouter = {
  path: '/roles',
  component: Layout,
  redirect: '/roles/list',
  name: 'roles',
  meta: {
    title: '权限管理',
    icon: 'department'
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/roles/list');
    },
    name: 'rolesList',
    meta: {
      title: '角色管理',
      icon: 'edit'
    }
  }, {
    path: 'apiList',
    component: function component() {
      return import('@/views/roles/apiList');
    },
    name: 'rolesApiList',
    meta: {
      title: '接口管理',
      icon: 'edit'
    }
  }]
};
export default roleRouter;